var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.5C18.6274 24.5 24 19.1274 24 12.5C24 5.87258 18.6274 0.5 12 0.5C5.37258 0.5 0 5.87258 0 12.5C0 19.1274 5.37258 24.5 12 24.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1551 6.11719H9.46278C7.30394 6.11719 5.55273 7.86842 5.55273 10.0273V14.7195C5.55273 16.879 7.30394 18.6296 9.46278 18.6296H14.1551C16.3145 18.6296 18.0651 16.8784 18.0651 14.7195V10.0273C18.0651 7.86842 16.3145 6.11719 14.1551 6.11719ZM16.8923 14.7195C16.8923 16.2288 15.6643 17.4568 14.1551 17.4568H9.46278C7.95353 17.4568 6.72552 16.2294 6.72552 14.7195V10.0273C6.72552 8.51801 7.95353 7.28997 9.46278 7.28997H14.1551C15.6643 7.28997 16.8923 8.51744 16.8923 10.0273V14.7195ZM11.8089 9.24556C10.0816 9.24556 8.68054 10.6461 8.68054 12.3739C8.68054 14.1012 10.0811 15.5024 11.8089 15.5024C13.5368 15.5024 14.9373 14.1018 14.9373 12.3739C14.9373 10.6461 13.5368 9.24556 11.8089 9.24556ZM11.8089 14.3284C10.7312 14.3284 9.8539 13.4511 9.8539 12.3734C9.8539 11.2951 10.7312 10.4184 11.8089 10.4184C12.8866 10.4184 13.7639 11.2951 13.7639 12.3734C13.7639 13.4511 12.8866 14.3284 11.8089 14.3284ZM15.1719 8.59428C14.9413 8.59428 14.7551 8.78101 14.7551 9.01101C14.7551 9.24102 14.9419 9.42775 15.1719 9.42775C15.4019 9.42775 15.5886 9.24102 15.5886 9.01101C15.5886 8.78044 15.4019 8.59428 15.1719 8.59428Z",
    fill: "url(#paint0_linear_1422_32041)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1422_32041",
    x1: 11.8089,
    y1: 6.11719,
    x2: 11.8089,
    y2: 18.6296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B3CDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111111,
    stopColor: "#9D009B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222222,
    stopColor: "#C6008A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#E4007D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444444,
    stopColor: "#EF0065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555556,
    stopColor: "#FC402A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#FF4C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#FDAF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE516"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.9c05586ed19a6b82bd5a2f376e9e7ea0.svg";
export { ForwardRef as ReactComponent };